(() => {
  const config = document.getElementById('kehwah-launch-products');
  if (!config) return;
  const ids = new Set(JSON.parse(config.textContent).filter(Boolean).map(String));
  const originals = new WeakMap();
  function refresh() {
    document.querySelectorAll('.jdgm-preview-badge').forEach(widget => {
      if (!ids.has(widget.getAttribute('data-id'))) return;
      const badge = widget.querySelector('.jdgm-prev-badge');
      const label = badge?.querySelector('.jdgm-prev-badge__text');
      if (!label) return;
      const raw = badge.getAttribute('data-number-of-reviews');
      const count = raw !== null && /^\d+$/.test(raw) ? Number(raw) : null;
      if (count === 0) {
        if (!originals.has(label)) originals.set(label, label.textContent);
        badge.removeAttribute('data-kehwah-launch');
        // A zero-review badge is not evidence of a new launch or a rating.
        widget.setAttribute('data-kehwah-empty-reviews', '');
      } else {
        widget.removeAttribute('data-kehwah-empty-reviews');
        badge.removeAttribute('data-kehwah-launch');
        if (label.textContent === 'New launch') label.textContent = count > 0 ? `${count} ${count === 1 ? 'review' : 'reviews'}` : (originals.get(label) || '');
        originals.delete(label);
      }
    });
  }
  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    queueMicrotask(() => { queued = false; refresh(); });
  });
  observer.observe(document.body, {subtree: true, childList: true, attributes: true, attributeFilter: ['data-number-of-reviews', 'data-id']});
  refresh();
})();
